import React, {Component} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {OverlayTrigger} from "react-bootstrap";
import SupplierRatePopover from "../popovers/SupplierRatePopover";
import Moment from "react-moment";
import Documents from "../components/Documents";
import BackEnd from "../../../../backend/BackEnd";
import ActionLink from "../../../../controls/ActionLink";
import ConfirmAcceptanceModal from "../modals/ConfirmAcceptanceModal";
import ShareUrlPopover from "../../popovers/ShareUrlPopover";
import PdfViewerModal from "../../../../modals/PdfViewerModal";

const $ = window.jQuery;

class IncomingTenderRequest extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        onRemove: PropTypes.func
    };
    static defaultProps = {};
    state = {
        showConfirmAcceptanceModal: false,
        dataConfirmAcceptanceModal: null,
        taxTypeId: this.props.data.taxTypeId,
        items: this.props.data.items,
        showSpecificationModal: false,
        specificationId: null
    };

    render() {
        const {data, ...props} = this.props;
        return (
            <div className="panel" id="first-tender" role="incoming-tender-request">
                <div className="panel-heading">
                    <span className="panel-title">
                        <Link to={`/tenders/${this.props.data.tenderId}`}>
                            <strong>№ {data.tenderNumber}</strong>
                        </Link>
                        {" "}
                        <small><Moment locale="ru" format="DD.MM.YYYY HH:mm">{data.createdAt}</Moment></small>
                    </span>
                    <div className="panel-heading-controls">
                        {/*<span className="panel-heading-text"><i className="fa fa-comment-o"/>*/}
                        {/*&nbsp;3*/}
                        {/*&nbsp;&nbsp;|&nbsp;&nbsp;*/}
                        {/*</span>*/}
                        {/*<button className="btn btn-danger btn-xs btn-outline" id="reject-tender">Отказаться</button>*/}
                        <OverlayTrigger ref={el => this.shareUrlPopoverOverlay = el}
                                        trigger="click" placement="top"
                                        rootClose
                                        overlay={<ShareUrlPopover
                                            url={`${window.location.origin}/tenders/${this.props.data.tenderId}`}
                                            close={() => this.shareUrlPopoverOverlay.hide()}/>}>
                            <button type="button" className="btn btn-default btn-xs btn-outline btn-outline-colorless">
                                <i className="fa fa-link"/> Ссылка
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                <div className="panel-body" style={{position: "relative"}}>
                    {
                        data.solelyOne &&
                        <a href="#" className="label label-warning label-corner left">
                            <span className="label-corner-content"><i className="fa fa-star"/></span>
                        </a>
                    }
                    <div className="row">
                        <div className="col-sm-9">
                            {this.state.items.map(item =>
                                <div key={item.id} className="row">
                                    <div className="col-sm-9">
                                        <strong className="font-size-14">{item.name}</strong>
                                        <div className="m-l-1 m-t-1">
                                            <div className="row">
                                                <div className="col-sm-4">Кол-во</div>
                                                <div className="col-sm-8"><strong>{item.count}</strong> шт.
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Дата доставки</div>
                                                <div className="col-sm-8">
                                                    <b>
                                                        <Moment locale="ru"
                                                                format="DD.MM.YYYY">
                                                            {data.deliveryDate}
                                                        </Moment>
                                                    </b>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Адрес доставки</div>
                                                <div className="col-sm-8">{data.deliveryAddress}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Доставка</div>
                                                <div className="col-sm-8">{data.deliveryTypeName}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Клиент</div>
                                                <div className="col-sm-8">{data.payer}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">Условия оплаты</div>
                                                <div className="col-sm-8">{data.paymentConditions}</div>
                                            </div>
                                            <div className="row m-t-2">
                                                <div className="col-sm-12">
                                                    {
                                                        item.specDocumentId &&
                                                        <div>
                                                            <i className="fa fa-file-pdf-o"/>
                                                            &nbsp;
                                                            <ActionLink onClick={() => this.showSpecification(item)}>
                                                                Посмотреть требования к паллетам
                                                            </ActionLink>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="row">
                                            <div className="col-sm-10 col-sm-offset-2">
                                                {
                                                    item.providerRate &&
                                                    <div>
                                                        <small>Ваша цена:</small>
                                                        <br/>
                                                        <strong className="font-size-20 text-info">
                                                            {item.providerRate}&nbsp;р.
                                                        </strong> {this.state.taxTypeId === 1 ? "с НДС" : "без НДС"}
                                                        <br/>
                                                        <ActionLink className="text-danger"
                                                                    onClick={() => this.resetSupplierRate(item)}>
                                                            Сбросить
                                                        </ActionLink>
                                                    </div>
                                                }
                                                <div>
                                                    <small>Рекомендуемая цена:</small>
                                                    <br/>
                                                    <strong className="font-size-20">
                                                        {item.proposedRateWithTax}&nbsp;р.
                                                    </strong> с НДС
                                                    <br/>
                                                    <strong className="font-size-20">
                                                        {item.proposedRateWithoutTax}&nbsp;р.
                                                    </strong> без НДС
                                                </div>
                                                {
                                                    !item.providerRate &&
                                                    <div>
                                                        <OverlayTrigger ref="supplierRatePopoverOverlay"
                                                                        trigger="click" placement="top"
                                                                        rootClose
                                                                        overlay={<SupplierRatePopover
                                                                            rate={item.providerRate}
                                                                            onSave={rate => this.updateSupplierRate(item, rate)}
                                                                            close={() => this.refs.supplierRatePopoverOverlay.hide()}/>}>
                                                            <button className="btn btn-xs btn-default"
                                                                    role="open-supplier-rate-popover">
                                                                Дать свою цену
                                                            </button>
                                                        </OverlayTrigger>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-md-3">
                            <div>
                                <button type="button" className="btn btn-primary btn-block" id="accept-tender"
                                        onClick={() => this.acceptTenderRequest()}>
                                    Участвовать
                                </button>
                            </div>
                            <div className="m-t-1 text-center">
                                <label className="custom-control custom-radio radio-inline">
                                    <input type="radio" className="custom-control-input"
                                           name={`taxTypeId-${data.tenderId}`}
                                           value="1" checked={this.state.taxTypeId === 1}
                                           onChange={event => this.updateTaxTypeId(event.target.value)}/>
                                    <span className="custom-control-indicator"/>
                                    <strong>с НДС</strong>
                                </label>
                                <label className="custom-control custom-radio radio-inline">
                                    <input type="radio" className="custom-control-input"
                                           name={`taxTypeId-${data.tenderId}`}
                                           value="2" checked={this.state.taxTypeId === 2}
                                           onChange={event => this.updateTaxTypeId(event.target.value)}/>
                                    <span className="custom-control-indicator"/>
                                    <strong>Без НДС</strong>
                                </label>
                            </div>
                            {
                                data.isPriceWithDelivery &&
                                <p className="m-t-1 text-center">цена с учётом доставки</p>
                            }
                        </div>
                    </div>
                    {
                        data.type.id === 1 &&
                        <span className="label label-primary label-ribbon label-ribbon-bottom right">
                            Покупка
                        </span>
                    }
                    {
                        data.type.id === 2 &&
                        <span className="label label-danger label-ribbon label-ribbon-bottom right">
                            Продажа
                        </span>
                    }
                </div>
                <div className="panel-footer">
                    <Documents entityId={data.tenderId} entityName="Tender" propertyName="SupplierDocuments"/>
                </div>
                <PdfViewerModal documentId={this.state.specificationId}
                                show={this.state.showSpecificationModal}
                                onHide={() => this.setState({showSpecificationModal: false})}/>
                <ConfirmAcceptanceModal show={this.state.showConfirmAcceptanceModal}
                                        data={this.state.dataConfirmAcceptanceModal}
                                        onConfirm={() => this.confirmAcceptance()}
                                        onHide={() => this.setState({showConfirmAcceptanceModal: false})} />
            </div>
        );
    }

    async updateSupplierRate(tenderRequestItem, rate) {
        const items = this.state.items;

        items[items.indexOf(tenderRequestItem)].providerRate = rate;

        this.setState({items});

        const setProviderRate = new BackEnd.TenderRequests.SetProviderRate();
        const result = await setProviderRate.call({
            tenderRequestId: this.props.data.tenderRequestId,
            dto: {
                supplierRate: rate
            }
        });

        if (result.success) {

        }
    }

    async resetSupplierRate(tenderRequestItem) {
        await this.updateSupplierRate(tenderRequestItem, null);
    }

    acceptTenderRequest() {
        const {deliveryDate} = this.props.data;
        const {taxTypeId, items} = this.state;

        this.setState({
            showConfirmAcceptanceModal: true,
            dataConfirmAcceptanceModal: {taxTypeId, deliveryDate, items}
        });
    }

    async confirmAcceptance() {
        const {onRemove} = this.props;

        let acceptEndpoint = new BackEnd.TenderRequests.Accept();
        let result = await acceptEndpoint.call({
            tenderRequestId: this.props.data.tenderRequestId
        });

        if (onRemove) onRemove();
        $(document).trigger('fetchCounters');
    }

    async updateTaxTypeId(taxTypeId) {
        taxTypeId = parseInt(taxTypeId);

        this.setState({taxTypeId});

        let setTaxType = new BackEnd.TenderRequests.SetTaxType();
        let result = await setTaxType.call({
            tenderRequestId: this.props.data.tenderRequestId,
            dto: {taxTypeId}
        });
    }

    showSpecification(item) {
        this.setState({
            showSpecificationModal: true,
            specificationId: item.specDocumentId
        });
    }
}

export default IncomingTenderRequest;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/Incoming/IncomingTenderRequest.js